export default {
    "USER": {
        "NAME": "Name",
        "PASSWORD": "Password",
        "NEW_PASSWORD": "New password",
        "PASSWORD_CONFIRMATION": "Password confirmation",
        "LANGUAGE": "Language",
        "LOGIN": "Login",
        "EMAIL": "Email",
        "LOGGINGIN": "Logging in ...",
        "LOGGEDIN": "Logged in",
        "ROLE": "Role",
        "FIRST_NAME": "First name",
        "LAST_NAME": "Last name",
        "COUNTRY": "Country",
        "BIRTHDAY": "Birthdate",
        "MISC": "Misc",
        "ALLOW_NOTIFICATIONS": "Enable push messages",
    }
}


// WEBPACK FOOTER //
// ./src/i18n/messages/en/user.js